import { autonomyColor } from './autonomyColor'

// Base Autonomy colors (current theme)
export const autonomyColors = {
  ...autonomyColor,
  // UI component colors for Autonomy theme
  sidebarBackground: autonomyColor.deepBlue,
  sidebarActive: autonomyColor.cyan,
  buttonColor: autonomyColor.cyan,
  buttonHover: autonomyColor.lightCyan,
}

// Default theme colors (when no client is selected)
// Based on Autonomy but with neutral/muted tones
export const defaultColors = {
  ...autonomyColor,
  // Make primary accents more neutral
  cyan: '#4A90A4', // Muted cyan
  pink: '#A67C9A', // Muted pink
  // Softer blues
  lightBlue: '#5A8B94',
  lightCyan: '#4A6B75',
  // Maintain contrast but less vibrant
  deepBlue: '#1A2F3A',
  darkBlue: '#2A3F4A',
  mediumBlue: '#3A4F5A',
  // UI component colors for Default theme
  sidebarBackground: '#1A2F3A',
  sidebarActive: '#4A90A4',
  buttonColor: '#4A90A4',
  buttonHover: '#4A6B75',
}

// Galpin theme colors (for Galpin client)
// Based on Ford Motor Company brand colors
export const galpinColors = {
  ...autonomyColor,
  // Ford Motor Company brand colors
  cyan: '#003478', // Ford Blue (primary brand color)
  pink: '#0066CC', // Lighter Ford Blue for accents
  // Ford-inspired blues
  lightBlue: '#0052A3',
  lightCyan: '#003478',
  // Ford brand backgrounds
  deepBlue: '#001A33',
  darkBlue: '#002244',
  mediumBlue: '#003478',
  // Ford complementary colors
  silver: '#C0C0C0', // Ford Silver
  lightSilver: '#E8E8E8',
  // UI component colors for Galpin theme
  sidebarBackground: '#001A33', // Dark Ford Blue for sidebar
  sidebarActive: '#C0C0C0', // Light silver for active items
  buttonColor: '#C0C0C0', // Light silver for buttons and links
  buttonHover: '#E8E8E8', // Lighter silver on hover
}

export type ClientTheme = 'autonomy' | 'default' | 'galpin'

export const getColorsForTheme = (theme: ClientTheme) => {
  switch (theme) {
    case 'autonomy':
      return autonomyColors
    case 'galpin':
      return galpinColors
    case 'default':
    default:
      return defaultColors
  }
}
